import { useChartStore } from '@/stores/chartStore';
import { clearRecidsOfChartAndLoadSymbolOnlyChartBeingViewed } from '@/composables/clearRecidsOfChartAndLoadSymbolOnlyChartBeingViewed';
import { SimpleFrontendChart } from '@/interfaces/chart';

export function clearRecidsOfChartAndLoadSymbolOnlyChartBeingViewedIfSymbolHasChanged(chart: SimpleFrontendChart) {
  const chartStore = useChartStore();

  if (chart.symbol !== chartStore.symbol) {
    clearRecidsOfChartAndLoadSymbolOnlyChartBeingViewed(chart.recid);
  }
}
